import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { useRef as x, useState as u, useEffect as d } from "react";
import o from "./hero-full-width-video.module.less.js";
import { isInDebugMode as f } from "../../../helpers/debug-helper.js";
import n from "../../../animation/animation.module.less.js";
import { useIntersectionObserver as N } from "usehooks-ts";
import { SecondaryIconButton as V } from "../button/button.js";
import { useTranslation as j } from "react-i18next";
const E = {
  autoPlay: !0,
  loop: !0,
  muted: !0,
  playsInline: !0,
  controls: !1
}, A = ({
  videoUrlDesktop: m,
  videoUrlMobile: p,
  enableImageOverlay: a,
  enablePauseButton: v = !1,
  blockIndex: y
}) => {
  const e = x(null), [h, I] = u(!1), [s, l] = u(!1), { isIntersecting: t, ref: g } = N({
    threshold: 0
  });
  d(() => {
    t && I(!0), t && e.current && !s && (e.current.play(), f() && console.log("Playing video")), !t && e.current && (e.current.pause(), f() && console.log("Pausing video"));
  }, [t]), d(() => {
    s ? e.current?.pause() : e.current?.play();
  }, [s]);
  const P = [
    y === 0 ? n.fadeIn400 : h ? n.fadeIn400 : "",
    n.opacity0
  ].join(" "), { t: c } = j();
  return /* @__PURE__ */ r("div", { className: P, children: [
    a && /* @__PURE__ */ i("div", { className: o.imageOverlay }),
    /* @__PURE__ */ r(
      "div",
      {
        onClick: () => l(!s),
        ref: g,
        className: [o.fullWidthVideoWrapper, a ? o.enableImageOverlay : ""].join(" "),
        children: [
          v && /* @__PURE__ */ i(
            V,
            {
              onClick: () => l(!s),
              className: o.pauseButton,
              icon: s ? "ui-icon-play-filled" : "ui-icon-pause-filled",
              ariaLabel: c(s ? "PLAY_VIDEO" : "PAUSE_VIDEO")
            }
          ),
          /* @__PURE__ */ r("video", { ref: e, ...E, className: o.fullWidthVideo, children: [
            /* @__PURE__ */ i("source", { src: p, type: "video/mp4", media: "(max-width: 767px)" }),
            /* @__PURE__ */ i("source", { src: m, type: "video/mp4", media: "(min-width: 768px)" })
          ] })
        ]
      }
    )
  ] });
};
export {
  A as default
};
